// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contact-list":"contact-list","dialer-input":"dialer-input","dialer-icon":"dialer-icon","dialer-key-btn":"dialer-key-btn"};